<template>
  <section>
    <ResourcesTrainingHeader />
    <ResourcesTrainingIntro />
    <ResourcesTrainingIndex />
  </section>
</template>

<script>
import * as partials from './partials'

export default {
  name: 'ResourcesTraining',
  components: { ...partials }
}
</script>
